export default __webpack_public_path__ + "static/media/result_medicine.1a69777c.svg";